import gql from 'graphql-tag';

export default gql`
    query($organizationId: String!) {
        crosschainTransfersAmountLimits(organizationId: $organizationId) {
          min,
          max
        }
    }
`;